<template>
  <div>
    <div class="px-0 px-md-3 px-sm-0">
      <div class="row">
        <div class="d-flex col my-2">
          <icon-view
            icon="fas fa-user-circle"
            icon-color="#ff7058"
            icon-size="27px;"
            variant="custom-icon"
          />
          <div class="d-flex flex-column col-12">
            <span class="color-secondary-6 font-14">Especialista:</span>
            <span class="font-16 color-black font-weight-bold">
              {{ data.specialist }}
            </span>
          </div>
        </div>

        <div class="d-flex col my-2">
          <em
            class="
              total-amount-view__icon
              icon-block
              gray-color
              fas
              fa-user-friends
            "
          />
          <div class="d-flex flex-column col-12">
            <span class="color-secondary-6 font-14">Total de Contratos:</span>
            <div class="color-black font-weight-bold font-25">
              {{ data.totalContracts }}
            </div>
          </div>
        </div>

        <div class="d-flex col my-2">
          <em
            class="
              total-amount-view__icon
              icon-block
              color-green
              fas
              fa-check-circle
            "
          />
          <div class="d-flex flex-column col-12">
            <span class="color-secondary-6 font-14">Documentos Cargados:</span>
            <div class="color-black font-weight-bold font-25">
              {{ data.uploadedDocuments }}
            </div>
          </div>
        </div>

        <div class="d-flex col my-2">
          <em
            class="total-amount-view__icon icon-block yellow-color fas fa-clock"
          />
          <div class="d-flex flex-column col-12">
            <span class="color-secondary-6 font-14">
              Documentos Pendientes:
            </span>
            <div class="color-black font-weight-bold font-25">
              {{ data.pendingDocuments }}
            </div>
          </div>
        </div>

        <div class="d-flex col my-2">
          <em
            class="total-amount-view__icon icon-block color-primary-4 fas fa-times-circle"
          />
          <div class="d-flex flex-column col-12">
            <span class="color-secondary-6 font-14">
              Documentos Con Error:
            </span>
            <div class="d-flex align-items-center">
              <div class="color-black font-weight-bold font-25">
                {{ model.failedUploadsCount }}
              </div>
              <u
                v-if="model.failedUploadsCount > 0"
                class="ml-3 color-green cursor-pointer"
                @click="showErrorTab"
              >
                Ver Detalles
              </u>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />
  </div>
</template>

<script>
import IconView from 'icon-view';
export default {
  name: 'SummaryHeaderRow',
  components: {
    IconView,
  },
  data() {
    return {
      model: {
        validations: [],
        showAlert: false,
        failedUploadsCount: 0,
      },
    };
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    fileErrorData: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    showErrorTab() {
      this.$emit('show-alert-tab', true);
    },
  },
  watch: {
    fileErrorData: {
      immediate: true,
      handler(val) {
        this.model = val;
      },
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';

.icon-block {
  font-size: 15px;
  margin-top: 4px;
}
.yellow-color {
  color: map-get($colors, 'yellow-star');
}
.gray-color {
  color: map-get($colors, 'secondary-6');
}

::v-deep .custom-icon {
  margin-bottom: 15px;
  .dot {
    width: 31px !important;
    height: 31px !important;
    margin-right: 5px;
    .title-icon {
      margin-top: 1px !important;
      font-size: 28px;
    }
  }
}
</style>
